
<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-0">Ticket Status Review</h4>
        
      </div>
      <button class="btn btn-secondary btn-sm" (click)="appservice.goback()">Back</button>
    </div>
    <div class="card-body">
      <form>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Employee ID</label>
          <!-- <select class="form-select" [(ngModel)]="Ticket.employeeid" name="employeeId" (change)="Onselectempolyee()">
            <option value="">Select Employee</option>
            <option *ngFor="let emp of employeeid" [value]="emp.OD_EmployeeID">{{ emp.OD_EmployeeID }}</option>
          </select> -->
        
          <input class="form-control" [(ngModel)]="Ticket.TR_Employeeid" name="TR_Employeeid" />
        
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Requester MailId</label>
          <input class="form-control" [(ngModel)]="Ticket.TR_RequesterMailid" name="TR_RequesterMailid" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Department</label>
          <input class="form-control" [(ngModel)]="Ticket.TR_Department" name="TR_Department" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Source</label>
          <input class="form-control" [(ngModel)]="Ticket.TR_Source" name="designation" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Type</label>
          <input class="form-control" [(ngModel)]="Ticket.TR_Type" name="grade" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Status</label>
          <input class="form-control" [(ngModel)]="Ticket.TR_Status" name="dateOfJoining" type="text" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Priority</label>
          <input class="form-control" [(ngModel)]="Ticket.TR_Priority" name="plant" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Subject</label>
          <input class="form-control" [(ngModel)]="Ticket.TR_subject" name="department" />
        </div>
<div class="row">
  <div class="col-md-8">
    <!-- your existing form -->
  </div>

  <!-- <div class="col-md-4 d-flex justify-content-center align-items-start">
    <img
      *ngIf="Ticket.TR_Attachment"
      [src]="'data:' + Ticket.TR_FileType + ';base64,' + Ticket.TR_Attachment"
      alt="Attachment"
      class="img-thumbnail"
      style="max-width: 200px; max-height: 200px;"
      (click)="openPreview('data:' + Ticket.TR_FileType + ';base64,' + Ticket.TR_Attachment)"
    />
  </div> -->
  <!-- <div class="image-popup" *ngIf="fullImage" (click)="closePreview()">
  <img [src]="fullImage" class="image-popup-content" />
</div> -->
</div>

 <!-- <div class="mb-3 d-flex align-items-center" *ngIf="Ticket.TR_Reason!=''">
          <label class="form-label me-3" style="width: 150px;">Reason</label>
          <input class="form-control" [(ngModel)]="Ticket.TR_Reason" name="TR_Reason" />
        </div> -->

        <!-- <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Requester</label>
          <input class="form-control" [(ngModel)]="Ticket.requester" name="requester" />
        </div>
        <div class="mb-3 d-flex align-items-center" *ngIf="appservice.editchecker==='rejected'">
  <label class="form-label me-3" style="width: 150px;">Comments</label>
  <textarea
  class="form-control"
  [(ngModel)]="Ticket.command"
  name="command"
  style="height: 50px;"
  placeholder="Reason">
</textarea>

</div> -->

        <div class="action-buttons d-flex justify-content-start gap-2 mt-3">
          <button *ngIf="Ticket.TR_ITcloserstatus!='OnProcess'" class="btn btn-approve" type="button" (click)="Pending('Resend')" >Resend</button>
           <!-- <button class="btn btn-warning" type="button" (click)="Pending()" >Pending</button> -->
          <button *ngIf="Ticket.TR_ITcloserstatus!='OnProcess'" class="btn btn-decline" type="button" (click)="Pending('Close')" >Close</button>
        </div>
      </form>
    </div>
  </div>
</div>
